const pwdReset = {
  TITLE: "パスワードのリセット",
  TIP: "パスワードのリセット通知を送ります",
  MAIL_SURE_LABEL: "メールアドレス（確認）",
  SUBMIT_BTN: "送信",
};
export default pwdReset;
